import { Col } from "react-bootstrap";

// This is a component for Project Cards to display for each
export const ProjectCard = ({
  title,
  description,
  imgUrl,
  onClick,
  skills,
  details,
}) => {
  return (
    <Col sm={6} md={4}>
      <div
        className="proj-imgbx"
        onClick={onClick}
        style={{ cursor: "pointer" }}
      >
        <img src={imgUrl} alt="iamge" />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
    </Col>
  );
};
